var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Device, getPlatform, getSSOUrl, getUa, getYxdSSOUrl } from '../system';
import { getGameKey, getParams } from '../utils';
import clientInit from './clientInit';
import compareVersion from './compareVersion';
var _a = getUa(), is3387Game = _a.is3387Game, is3387IOSSDK = _a.is3387IOSSDK, is3387JSAPPSDK = _a.is3387JSAPPSDK, is3387SDK = _a.is3387SDK, isHykbAndroid = _a.isHykbAndroid, isHykbIos = _a.isHykbIos, isWeixinMini = _a.isWeixinMini, isWeixinMiniPc = _a.isWeixinMiniPc, is4399GameBox = _a.is4399GameBox, is4399SDK = _a.is4399SDK, is4399IosSDK = _a.is4399IosSDK, is4399wan = _a.is4399wan;
var _b = getPlatform(), is3387 = _b.is3387, is4399H5 = _b.is4399H5, is4399Sy = _b.is4399Sy, is4399Dj = _b.is4399Dj, is4399Mini = _b.is4399Mini, isHykb = _b.isHykb, isYxd = _b.isYxd, isTest = _b.isTest, is4399IosSyPublish = _b.is4399IosSyPublish, is4399IosSyGamebox = _b.is4399IosSyGamebox, is4399Yy = _b.is4399Yy, isZhkf = _b.isZhkf, isCzkf = _b.isCzkf;
var device = new Device();
// 业务通过浏览器方式打开
var checkBrowser = function (platform) {
    window.IM.isClient = false;
    if (device.isMobile) {
        window.IM.runtime = "".concat(platform, "-browser-wap");
        return;
    }
    window.IM.runtime = "".concat(platform, "-browser-web");
};
// 业务通过小程序方式打开
var checkMiniProgram = function (platform) {
    if (isWeixinMiniPc) {
        window.IM.runtime = "".concat(platform, "-mini-web");
        return;
    }
    if (isWeixinMini) {
        window.IM.runtime = "".concat(platform, "-mini-wap");
        return;
    }
    checkBrowser(platform);
};
var check3387 = function () { return __awaiter(void 0, void 0, void 0, function () {
    var sdkInfo, sdkDevice, is3387JSH5SDK, is3387JSIOS;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, clientInit.getSDKInfo()];
            case 1:
                sdkInfo = _a.sent();
                sdkDevice = JSON.parse(sdkInfo.device || '{}');
                is3387JSH5SDK = sdkDevice.RUNTIME === 'js_wap';
                is3387JSIOS = window.__iosApp__ === true;
                // 应用内在线玩SDK
                if (is3387JSAPPSDK) {
                    window.IM.runtime = '3387-android-jssdk';
                    return [2 /*return*/];
                }
                // 安卓客户端SDK
                if (is3387SDK) {
                    window.IM.runtime = '3387-android-sdk';
                    return [2 /*return*/];
                }
                // IOS客户端SDK
                if (is3387IOSSDK) {
                    window.IM.runtime = '3387-ios-sdk';
                    return [2 /*return*/];
                }
                // 安卓客户端APP
                if (is3387Game) {
                    window.IM.runtime = '3387-android-app';
                    return [2 /*return*/];
                }
                // ios js App
                if (is3387JSIOS) {
                    window.IM.runtime = '3387-ios-app';
                    return [2 /*return*/];
                }
                // 应用外在线玩SDK
                // if (is3387JSH5SDK) {
                //     window.IM.runtime = '3387-browser-jssdk';
                //     return;
                // }
                checkBrowser(3387);
                return [2 /*return*/];
        }
    });
}); };
var checkHykb = function () {
    // 好游快爆安卓APP
    if (isHykbAndroid) {
        window.IM.runtime = 'hykb-android-app';
        return;
    }
    // 好游快爆IOSAPP
    if (isHykbIos) {
        window.IM.runtime = 'hykb-ios-app';
        return;
    }
    checkBrowser('hykb');
};
var check4399H5 = function () {
    var _a;
    var searchParams = (_a = window.location) === null || _a === void 0 ? void 0 : _a.search.substring(1);
    var platform_runtime = getParams(searchParams, 'platform_runtime') || '';
    // 在线玩wap悬浮球
    if (platform_runtime === 'js-wap') {
        window.IM.runtime = '4399h5-js-wap';
        return;
    }
    // 在线玩APP
    if (is4399wan) {
        window.IM.runtime = '4399h5-android-wanapp';
        return;
    }
    window.IM.ssoUrl = getSSOUrl();
    checkBrowser('4399h5');
};
var check4399Sy = function () {
    // 安卓客户端SDK
    if (is4399SDK) {
        window.IM.runtime = '4399sy-android-sdk';
        return;
    }
    checkBrowser('4399sy');
};
var check4399Dj = function () {
    // 安卓客户端SDK
    if (is4399SDK) {
        window.IM.runtime = '4399dj-android-sdk';
        return;
    }
    checkBrowser('4399dj');
};
var check4399IosSyPublish = function () {
    // IOS客户端SDK
    if (is4399IosSDK) {
        window.IM.runtime = '4399iossypublish-ios-sdk';
        return;
    }
    checkBrowser('4399iossypublish');
};
var check4399IosSyGamebox = function () {
    // IOS客户端SDK
    if (is4399IosSDK) {
        window.IM.runtime = '4399iossygamebox-ios-sdk';
        return;
    }
    checkBrowser('4399iossygamebox');
};
var check4399GameBox = function () {
    // 安卓客户端APP
    if (is4399GameBox) {
        window.IM.runtime = '4399gamebox-android-app';
        return;
    }
    checkBrowser('4399gamebox');
};
var checkYouxidian = function () {
    // 游戏店只有浏览器环境
    checkBrowser('youxidian');
};
var check4399Yy = function () {
    // 页游只有浏览器环境
    checkBrowser('4399yy');
};
var checkZhkf = function () {
    // 账号客服只有浏览器环境
    checkBrowser('zhkf');
};
var checkCzkf = function () {
    // 充值客服只有浏览器环境
    checkBrowser('czkf');
};
export var runtimeCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, uid, token;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, clientInit.init()];
            case 1:
                _b.sent();
                searchParams = (_a = window.location) === null || _a === void 0 ? void 0 : _a.search.substring(1);
                uid = getParams(searchParams, 'u') || getParams(searchParams, 'uid');
                token = getParams(searchParams, 'token');
                window.IM.env = {
                    development: 'development',
                    test: 'test',
                    test1: 'test',
                    test2: 'test',
                    ot: 'ot',
                    production: 'production'
                }[process.env.NODE_ENV];
                window.IM.gameKey = getGameKey(window.location.pathname.split('/'));
                window.IM.uid = uid;
                window.IM.u = uid;
                window.IM.token = token;
                window.IM.isClient = true;
                window.IM.CompareVersion = compareVersion;
                if (isTest) {
                    window.IM.ssoUrl = getSSOUrl();
                    checkBrowser('test');
                    return [2 /*return*/];
                }
                if (!is3387) return [3 /*break*/, 3];
                return [4 /*yield*/, check3387()];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3:
                if (isHykb) {
                    checkHykb();
                    return [2 /*return*/];
                }
                if (is4399Mini) {
                    checkMiniProgram('4399xcx');
                    return [2 /*return*/];
                }
                if (is4399H5) {
                    check4399H5();
                    return [2 /*return*/];
                }
                if (is4399Sy) {
                    check4399Sy();
                    return [2 /*return*/];
                }
                if (is4399Dj) {
                    check4399Dj();
                    return [2 /*return*/];
                }
                if (is4399IosSyPublish) {
                    check4399IosSyPublish();
                    return [2 /*return*/];
                }
                if (is4399IosSyGamebox) {
                    check4399IosSyGamebox();
                    return [2 /*return*/];
                }
                if (is4399GameBox) {
                    check4399GameBox();
                    return [2 /*return*/];
                }
                if (isYxd) {
                    window.IM.ssoUrl = getYxdSSOUrl();
                    checkYouxidian();
                    return [2 /*return*/];
                }
                if (is4399Yy) {
                    window.IM.ssoUrl = getSSOUrl();
                    check4399Yy();
                    return [2 /*return*/];
                }
                if (isZhkf) {
                    window.IM.ssoUrl = getSSOUrl();
                    checkZhkf();
                    return [2 /*return*/];
                }
                if (isCzkf) {
                    window.IM.ssoUrl = getSSOUrl();
                    checkCzkf();
                    return [2 /*return*/];
                }
                window.IM.isClient = false;
                window.IM.runtime = 'unknown';
                return [2 /*return*/];
        }
    });
}); };
